import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faArrowLeft, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';

// Custom colors for purple theme
const purpleAccent = '#8e44ad';
const lightPurple = '#a569bd';
const darkPurple = '#6c3483';

const ErrorPage = ({ message, onGoBack, onLogout }) => {
  return (
    <Container fluid className="vh-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#1e1e2f' }}>
      <Row className="w-100">
        <Col xs={12} sm={10} md={8} lg={6} className="mx-auto">
          <Card className="bg-dark text-white" style={{ borderColor: purpleAccent, borderWidth: '1px' }}>
            <Card.Header style={{ borderBottom: `1px solid ${purpleAccent}`, backgroundColor: '#2c2c40' }}>
              <div className="d-flex align-items-center">
                <FontAwesomeIcon 
                  icon={faExclamationTriangle} 
                  size="lg" 
                  className="me-2"
                  style={{ color: purpleAccent }} 
                />
                <h4 className="mb-0" style={{ color: lightPurple }}>BeatAI</h4>
              </div>
            </Card.Header>
            <Card.Body className="py-4">
              <div className="text-center mb-4">
                <h5 className="mb-3" style={{ color: lightPurple }}>Oops! Something went wrong</h5>
                <p style={{ color: '#e2e2e2' }}>{message || "We encountered an unexpected error"}</p>
              </div>
              
              <div className="small mb-4 text-center" style={{ color: '#a0a0a0' }}>
                <p>Please try again or contact support if the problem persists.</p>
              </div>

              <div className="d-flex justify-content-center gap-3 mt-4">
                <Button 
                  variant="outline-light" 
                  onClick={() => {
                    window.location.href = "/chat/"
                  }}
                  style={{ borderColor: purpleAccent, color: lightPurple }}
                >
                  <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                  to Lex
                </Button>
                <Button 
                  style={{ backgroundColor: purpleAccent, borderColor: darkPurple }}
                  onClick={() => {
                    localStorage.removeItem('accessToken');
                    window.location.reload()
                  }}
                >
                  <FontAwesomeIcon icon={faSignOutAlt} className="me-2" />
                  Logout
                </Button>
              </div>
            </Card.Body>
            
            {/* <Card.Footer className="text-center small border-top" 
              style={{ borderColor: purpleAccent, backgroundColor: '#2c2c40', color: '#a0a0a0' }}>
              <span></span>
            </Card.Footer> */}
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ErrorPage;